import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 bg-green-950/90 backdrop-blur-md text-white z-50 py-3 px-4 shadow-md border-b border-green-700/30" data-id="element-237">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-sm sm:text-base font-bold text-center uppercase tracking-wide" data-id="element-238">
        <span data-id="element-239">🔥 CUPOS LIMITADOS 🔥</span>
      </div>
    </div>;
}